import React from 'react';
import { Typography } from '@mui/material';

const Contact = () => {
	return (
		<div className="team-members">
			<div className="section-background">
				<img
					alt=""
					src="/contact/Profile-Pic-Contact.jpg"
					className="section-image"
				/>
				<div className="section-background-overlay"></div>
				<Typography variant="h2" className="section-title">
					Contact
				</Typography>
			</div>


			<div className='contact-wrapper'>

				<p>Email: yiyi.he@design.gatech.edu</p>
				<p>Office: 245 Fourth St NW, Suite 204E, Atlanta, GA 30332-0155</p>
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />



			</div>
		</div>);
};

export default Contact;